import { useAuth0 } from '@auth0/auth0-react';
import {
  AIStakeholderSummariesPopup,
  AnalyticsPopup,
  SentimentPopup,
} from 'components/Dashboard/Navigation/NotFeaturePopups';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { store } from 'components/Store';
import { useContext, useState } from 'react';

const ActivityTabs = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { activePlan } = state;

  const {
    data,
    activeTabState,
    scrollBarRef,
    noSearchCondition,
    generatingSummary,
    summaryFinishes,
    currentlyProcessing,
  } = props;
  const { enableAnalytics, enableSentiment } = activePlan ?? {};

  const { activeTab, setActiveTab } = activeTabState ?? {};

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSentiment, setIsOpenSentiment] = useState(false);
  const [isOpenAISummaries, setIsOpenAISummaries] = useState(false);
  const emptyMessage = data?.value?.filter((item) => item > 0).length === 0;

  const sentimentLowerCase =
    !!data?.labels?.[0] && !emptyMessage && !noSearchCondition ? data?.labels?.[0]?.toLowerCase() : 'neutral';
  const { isAuthenticated } = useAuth0();
  const isMobile = useIsMobile(1070);

  const createSections = () => {
    let sections = [
      {
        name: 'Activity',
        icon: 'key-update',
      },
      {
        name: 'AI summary',
        aiSummary: true,
      },
    ];
    let interestTab = {
      name: `Interest ${isMobile ? '' : 'over time'}`,
      tab: 'Mentions',
      icon: 'statistics',
    };

    let sentimentTab = {
      name: 'Sentiment',
      sentiment: true,
    };

    if (!enableAnalytics && isAuthenticated) {
      interestTab = {
        ...interestTab,
        blocked: true,
        customFunction: () => {
          setIsOpen(true);
        },
      };
      sentimentTab = {
        ...sentimentTab,
        blocked: true,
        customFunction: () => {
          setIsOpen(true);
        },
      };
    }

    if (!enableSentiment && isAuthenticated) {
      sentimentTab = {
        ...sentimentTab,
        blocked: true,
        customFunction: () => {
          setIsOpenSentiment(true);
        },
      };
    }

    sections = [...sections, interestTab, sentimentTab];
    return sections;
  };
  const sections = createSections();

  return (
    <>
      <div className='w-100 overflow-hidden scrollbar-right-fade'>
        <div className='flex-centered  px-4 py-4 px-lg-5 gap-15 flex-nowrap activity-tabs-container w-100 '>
          {sections
            ?.filter((item) => !item?.hidden)
            ?.map((item) => {
              const { name, tab, sentiment, icon, customFunction, blocked, aiSummary } = item ?? {};
              const propertyToUse = tab ?? name;
              return (
                <button
                  key={`element-${name}`}
                  className={`general-button nowrap-item biography-controllers-button border rounded-pill  ${
                    activeTab === propertyToUse ? `third-button text-white` : 'fourth-button'
                  }`}
                  onClick={() => {
                    if (customFunction) {
                      customFunction();
                    } else {
                      if (isAuthenticated) {
                        if (scrollBarRef.current) {
                          scrollBarRef.current.scrollToTop();
                        }
                        setActiveTab(propertyToUse);
                        dispatch({
                          type: 'MODIFY_SECTION',
                          parameter: 'stakeholderMobileSection',
                          value: 'activity',
                        });
                      } else {
                        if (propertyToUse === 'Mentions') {
                          setIsOpen(true);
                        } else if (propertyToUse === 'AI summary') {
                          setIsOpenAISummaries(true);
                        } else {
                          setIsOpenSentiment(true);
                        }
                      }
                    }
                  }}
                >
                  {sentiment ? (
                    <>
                      {blocked && isAuthenticated ? (
                        <span className='icon-padlock mr-2 d-inline-block-centered centered-2 paragraph-p2 opacity-7' />
                      ) : (
                        <span
                          className={`sentiment-bar-dot sentiment-dot mr-2 d-inline-block-centered mt-0 sentiment-dot-${sentimentLowerCase}`}
                        />
                      )}
                    </>
                  ) : aiSummary ? (
                    <>
                      {generatingSummary || currentlyProcessing?.state ? (
                        <i className='fas fa-spinner fa-spin d-inline-block-centered centered-2 mr-2' />
                      ) : summaryFinishes ? (
                        <span className='icon-circle-check  d-inline-block-centered title-h5-m centered-1 mr-2' />
                      ) : (
                        <img
                          style={{ width: '15px' }}
                          className='d-none d-md-inline-block d-inline-block-centered mr-2'
                          src={`${import.meta.env.VITE_APP_CDNURL}/images/${
                            activeTab === propertyToUse
                              ? '20250904-prospecting-icon-white'
                              : '20231216-prospecting-icon'
                          }.png`}
                          alt='Prospecting icon'
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {blocked && isAuthenticated ? (
                        <span className='icon-padlock mr-2 d-inline-block-centered centered-2 paragraph-p2 opacity-7' />
                      ) : (
                        <span
                          className={`icon-${icon} d-none d-xl-inline-block paragraph-p3 specific-right-margin-10`}
                        />
                      )}{' '}
                    </>
                  )}
                  {name}
                </button>
              );
            })}
        </div>
      </div>
      <AnalyticsPopup isOpen={isOpen} setIsOpen={setIsOpen} />
      <SentimentPopup isOpen={isOpenSentiment} setIsOpen={setIsOpenSentiment} />
      <AIStakeholderSummariesPopup isOpen={isOpenAISummaries} setIsOpen={setIsOpenAISummaries} />
    </>
  );
};

export default ActivityTabs;
